export const serenespalike = {
  name: 'Serene & Spa-like',
  color: [0.8862745098039215, 0.8745098039215686, 0.6352941176470588, 1],
  bg: [0.6313725490196078, 0.7450980392156863, 0.5843137254901961, 1],
  grid1: [0.5725490196078431, 0.6666666666666666, 0.7803921568627451, 1],
  grid2: [0.9294117647058824, 0.3411764705882353, 0.3215686274509804, 1],
}
